export default {
  DEFAULT: "default",
  PRODUCT_IMPRESSION: "product_impression",
  PRODUCT_CLICK: "product_click",
};
